import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiTwitter, FiFacebook, FiYoutube, FiLinkedin, FiMail, FiPhone } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const whatsappNumber = "+529844594738";
  const campusLink = "https://app.onlineclassesenglish.com";

  return (
    <footer className="bg-black text-white pt-20 pb-10 px-4 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12 mb-16">
        <div>
          <span className="font-black text-2xl tracking-tighter block mb-4 uppercase">
            ONLINE<span className="text-red-600">CLASSES</span><span className="text-green-600">ENGLISH</span>
          </span>
          <p className="text-gray-500 text-sm leading-relaxed mb-6">
            La universidad online de inglés para mexicanos. Aprende de profesores nativos, con salas de práctica 24/7 y sin instalaciones.
          </p>
          <div className="space-y-3">
            <a href={`https://wa.me/${whatsappNumber}`} className="flex items-center gap-3 text-green-500 font-bold hover:text-green-400 transition-colors">
              <SafeIcon icon={FaWhatsapp} /> {whatsappNumber} (24/7)
            </a>
            <a href="mailto:info@onlineclassesenglish.com" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
              <SafeIcon icon={FiMail} /> info@onlineclassesenglish.com
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div>
            <h4 className="font-black text-white uppercase text-xs tracking-widest mb-6">Explorar</h4>
            <ul className="space-y-4 text-sm text-gray-500 font-bold uppercase">
              <li><Link to="/shop" className="hover:text-yellow-500">Cursos</Link></li>
              <li><Link to="/shop?search=Salas" className="hover:text-yellow-500">Salas 24/7</Link></li>
              <li><a href="#pricing" className="hover:text-yellow-500">Precios</a></li>
              <li><a href={campusLink} className="hover:text-yellow-500">Entrar al Campus</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-black text-white uppercase text-xs tracking-widest mb-6">Legal</h4>
            <ul className="space-y-4 text-sm text-gray-500 font-bold uppercase">
              <li><Link to="#" className="hover:text-red-500">Privacidad</Link></li>
              <li><Link to="#" className="hover:text-red-500">Términos</Link></li>
              <li><Link to="#" className="hover:text-red-500">Garantía</Link></li>
            </ul>
          </div>
        </div>

        <div>
          <h4 className="font-black text-white uppercase text-xs tracking-widest mb-6">Sede</h4>
          <p className="text-gray-500 text-sm leading-relaxed">
            Playa del Carmen, Quintana Roo, México. <br/>
            Comunidad Global Activa 24/7.
          </p>
          <div className="flex gap-4 mt-6">
            {[FiYoutube, FiInstagram, FiFacebook, FiLinkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center hover:bg-white hover:text-black transition-all">
                <SafeIcon icon={Icon} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-zinc-900 pt-10 text-center">
        <p className="text-xs text-gray-600 font-bold uppercase tracking-widest">
          &copy; {new Date().getFullYear()} OnlineClassesEnglish.com. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;